import React from 'react';
import { useRouter } from 'next/router';
import icons from '../../shared/assets/icons/redesign';

import './OnlineCoursesIntro.scss';

const { Info, Check } = icons;

export default function OnlineCoursesIntro(props) {
  const router = useRouter();

  return (
    <div className="onlineCoursesIntro">
      <h2 className="onlineCoursesIntro-title">
        Welkom in de online cursussen omgeving
      </h2>

      <div className="onlineCoursesIntro-message">
        <Info className="onlineCoursesIntro-message-icon" />

        <p className="onlineCoursesIntro-message-text">
          Op dit moment zijn de online cursussen nog niet beschikbaar.
          We meten de interesse in deze nieuwe functionaliteit.
        </p>
      </div>

      <ul className="onlineCoursesIntro-list">
        <li className="onlineCoursesIntro-list-item">
          <div className="onlineCoursesIntro-list-item-icon-wrap">
            <Check className="onlineCoursesIntro-list-item-icon" />
          </div>

          18 maanden onbeperkt toegang tot 10 online cursussen
        </li>

        <li className="onlineCoursesIntro-list-item">
          <div className="onlineCoursesIntro-list-item-icon-wrap">
            <Check className="onlineCoursesIntro-list-item-icon" />
          </div>

          Afgestemd op je zwangerschap, bevalling, de babytijd en
          je partner
        </li>

        <li className="onlineCoursesIntro-list-item">
          <div className="onlineCoursesIntro-list-item-icon-wrap">
            <Check className="onlineCoursesIntro-list-item-icon" />
          </div>

          Gratis, afhankelijk van je verzekering. Anders maar 99,99
          euro voor het hele pakket
        </li>

        <li className="onlineCoursesIntro-list-item">
          <div className="onlineCoursesIntro-list-item-icon-wrap">
            <Check className="onlineCoursesIntro-list-item-icon" />
          </div>

          Meer dan 100 video’s en 1000+ minuten materiaal
        </li>
      </ul>

      <button
        className="onlineCoursesIntro-button"
        onClick={() => router.back()}
      >
        Terug
      </button>
    </div>
  );
}
